import { omit } from 'lodash-es'
import { type HTMLAttributes, forwardRef, useImperativeHandle, useRef } from 'react'
import LivePhoto, { type LivePhotoHandle, type LivePhotoProps } from './LivePhoto'

interface BasicProps {
	isPreview?: boolean
	isLivePhoto?: boolean
	src?: string
}
export interface ImageProps extends HTMLAttributes<HTMLImageElement>, BasicProps {}
export interface LivePhotoPictureProps extends LivePhotoProps, BasicProps {}

export type PictureProps = ImageProps | LivePhotoPictureProps

export type PictureHandle = {
	livePhoto: LivePhotoHandle | null
	image: HTMLImageElement | null
}
export default forwardRef<PictureHandle, PictureProps>(function Picture(
	{ isLivePhoto = false, isPreview = false, ...props },
	ref
) {
	const livePhotoRef = useRef<LivePhotoHandle | null>(null)
	const imageRef = useRef<HTMLImageElement | null>(null)

	useImperativeHandle(ref, () => ({
		get livePhoto() {
			return livePhotoRef.current
		},
		get image() {
			return imageRef.current
		},
	}))

	if (isLivePhoto) {
		return (
			<LivePhoto
				{...(omit(props, ['src']) as LivePhotoProps)}
				ref={livePhotoRef}
				isPreview={isPreview}
			/>
		)
	}

	return (
		<img
			referrerPolicy="no-referrer"
			loading="lazy"
			{...(props as ImageProps)}
			ref={imageRef}
			alt="图片"
		/>
	)
})
